import {
  type NodeInputType,
  OFFICE_EXTENSION_DISPLAY_TYPE,
} from '@/types/node-types';

/**
 * The display type an Office document URL should preview as, read off its
 * file extension, or null when the URL does not name one.
 */
export function officeDisplayTypeForUrl(url: string): NodeInputType | null {
  const match = /\.([a-z0-9]+)(?:[?#]|$)/i.exec(url);
  const extension = match?.[1]?.toLowerCase();
  return extension ? (OFFICE_EXTENSION_DISPLAY_TYPE[extension] ?? null) : null;
}

/**
 * A node result the preview panel renders as the document at `url`, in the
 * shape the document nodes stream live. Null when the URL is not an Office
 * document, since the panel would show it as text.
 */
export function officeDocumentResult(
  url: string,
): Record<string, unknown> | null {
  const displayType = officeDisplayTypeForUrl(url);
  if (!displayType) return null;
  return { display_modal: displayType, value: url, data: url, files: [] };
}
